<div class="background">
    <div>
        <img src="../../assets/images/logo-agrimaster-white.svg" alt="logo Agrimaster" class="logo" />
        <router-outlet></router-outlet>
    </div>
</div>